import { useEffect, useRef } from 'react';

type Args = {
  id: string | undefined;
};

export function useScrollToOnce({ id: idArg }: Args) {
  const idRef = useRef(idArg);

  useEffect(() => {
    const id = idRef.current;
    if (!id) return;

    const tileElement = document.getElementById(id);
    if (!tileElement) return;

    document.addEventListener(
      'readystatechange',
      () => tileElement.scrollIntoView({ block: 'center' }),
      { once: true },
    );
  }, []);
}
